export const LOCATIONS_OPTIONS = [
  {
    choice: 'None',
    value: '0',
    tracking: {
      class: 'voip-location-with-devices',
      id: 'voip-device-location-none',
      name: 'voip-device-location',
      text: 'None',
      type: 'submit'
    }
  },
  {
    choice: '1',
    value: '1',
    tracking: {
      class: 'voip-location-with-devices',
      id: 'voip-device-location-1',
      name: 'voip-device-location',
      text: '1',
      type: 'submit'
    }
  },
  {
    choice: '2-4',
    value: '2-4',
    tracking: {
      class: 'voip-location-with-devices',
      id: 'voip-device-location-2-4',
      name: 'voip-device-location',
      text: '2-4',
      type: 'submit'
    }
  },
  {
    choice: '5+',
    value: '5+',
    tracking: {
      class: 'voip-location-with-devices',
      id: 'voip-device-location-5',
      name: 'voip-device-location',
      text: '5+',
      type: 'submit'
    }
  }
]
